// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-lang-wrapper .duplicate-translation{\n    margin-top: 15px;\n    display: block;\n}\n.add-lang-wrapper .dig-actions-placeholder{\n    margin-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
